import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type {
  Calendar,
  CalendarPeriod,
} from 'app/typings/core/extranet/inventory/calendar';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useCalendar(
  hotelId?: number,
  calendarId?: number,
  period?: CalendarPeriod
) {
  return useQuery<Calendar | null>({
    queryKey: [
      CORE_QUERY_KEYS.calendar,
      {
        hotelId,
        calendarId,
        startDate: period?.startDate,
        endDate: period?.endDate,
      },
    ],
    queryFn: () =>
      hotelId && calendarId
        ? (apiRequest({
            path: ENDPOINTS.getCalendar,
            params: {
              hotelId: hotelId.toString(),
              calendarId: calendarId.toString(),
            },
            queryParams: {
              startDate: period?.startDate,
              endDate: period?.endDate,
            },
          }) as Promise<Calendar>)
        : Promise.resolve(null),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId && !!calendarId,
  });
}
